export default __webpack_public_path__ + "static/media/TD.39ec611b.svg";